module.exports = __webpack_public_path__ + "assets/icons/ic_warning_rounded_24px.svg";